import { ReactNode }  from 'react'
import { authenticationHttpService } from "@myinnsworth/httpServices";
import { AuthenticationMessages } from "@myinnsworth/httpServices/authentication/authenticationHttpService";
import ISignInResultModel from "@myinnsworth/httpServices/authentication/models/ISignInResultModel";
import IContact from "@myinnsworth/models/contact/IContact";
import IUser from "@myinnsworth/models/user/IUser";
import { useEffect, useState } from "react";
import AuthenticationContext, { AuthenticationState } from '@myinnsworth/contexts/AuthenticationContext';
import { useLocation, useNavigate } from 'react-router';
import ICaseSummary from '@myinnsworth/models/case/ICaseSummary';

interface IAuthenticationProviderProps {
    children?: ReactNode;
}

const AuthenticationProvider = (props: IAuthenticationProviderProps) => {
    const [authenticationState, setAuthenticationState] = useState<AuthenticationState>(authenticationHttpService.isAuthenticated ? AuthenticationState.SignedIn : AuthenticationState.SignedOut);
    const [user, setUser] = useState<IUser | undefined | null>(null);
    const [contact, setContact] = useState<IContact | undefined | null>(null);
    const [cases, setCases] = useState<Array<ICaseSummary>>([]);
    const nav = useNavigate();
    const location = useLocation();

    const onSignIn = (args: ISignInResultModel) => {
        setAuthenticationState(AuthenticationState.SignedIn);
        setUser(args.user);
        setContact(args.contact);
        setCases(args.cases);
    };

    const onSignOut = () => {
        setAuthenticationState(AuthenticationState.SignedOut);
        setUser(null);
        setContact(null);
        setCases([]);
        nav('/auth/sign-in');
    };

    const onSignInProgress = (type: string) => {
        setAuthenticationState(type === 'token' ? AuthenticationState.TokenRefresh : AuthenticationState.Authenticating);
        setUser(null);
        setContact(null);
        setCases([]);
    };

    useEffect(() => {
        if(!user && authenticationHttpService.isAuthenticated) {
            authenticationHttpService.signInWithToken()
                .then()
                .catch(_ => {});
        }
    }, [location.pathname, nav, authenticationState, user]);

    useEffect(() => {
        
        authenticationHttpService.on(AuthenticationMessages.SIGN_IN_SUCCESS_MESSAGE, onSignIn);
        authenticationHttpService.on(AuthenticationMessages.SIGNED_OUT_MESSAGE, onSignOut);
        authenticationHttpService.on(AuthenticationMessages.SIGN_IN_PROGRESS_MESSAGE, onSignInProgress);
    
        return () => {
            authenticationHttpService.removeListener(AuthenticationMessages.SIGN_IN_SUCCESS_MESSAGE, onSignIn);
            authenticationHttpService.removeListener(AuthenticationMessages.SIGNED_OUT_MESSAGE, onSignOut);
            authenticationHttpService.removeListener(AuthenticationMessages.SIGN_IN_PROGRESS_MESSAGE, onSignInProgress);
        };
    });
    
    return (
        <AuthenticationContext.Provider value={{user, contact, userCases: cases, state: authenticationState}}>
            {props.children}
            {/* {(authenticationState === AuthenticationState.TokenRefresh || authenticationState === AuthenticationState.Authenticating) && (<>Loading...</>)}
            {(authenticationState !== AuthenticationState.TokenRefresh && authenticationState !== AuthenticationState.Authenticating) && props.children} */}
        </AuthenticationContext.Provider>
    );
}

export default AuthenticationProvider;